import DashboardApi from "api/dashboardApi";
import * as types from "../actionTypes";
import { sendHttpRequest } from "./httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadOfferStats() {
  return async dispatch => {
    try {
      const stats = await dispatch(sendHttpRequest(DashboardApi.getOfferStats()));
      dispatch({ type: types.LOAD_OFFER_STATS_SUCCESS, payload: stats });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadActiveContractChartData(force) {
  return async (dispatch, getState) => {
    let { activeContractChartData } = getState().dashboard;
    if (!force && activeContractChartData) {
      return;
    }

    try {
      const data = await dispatch(sendHttpRequest(DashboardApi.getActiveContractChartData()));
      dispatch({ type: types.LOAD_ACTIVE_CONTRACT_CHART_DATA_SUCCESS, payload: data });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadAverageTimeStates(force) {
  return async (dispatch, getState) => {
    let { averageTimeStates } = getState().dashboard;
    if (!force && averageTimeStates) {
      return;
    }

    try {
      const data = await dispatch(sendHttpRequest(DashboardApi.getAverageTimeStates()));
      dispatch({ type: types.LOAD_AVERAGE_TIME_STATES_SUCCESS, payload: data });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadActivities() {
  return async dispatch => {
    try {
      const data = await dispatch(sendHttpRequest(DashboardApi.getActivities()));
      dispatch({ type: types.LOAD_ACTIVITIES_SUCCESS, payload: data });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
